/* src/components/notification-modal/notification-modal.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=notification-modal.component-HKVOCP7V.css.map */
